'use client';

import { useDAL } from '@/contexts/useDAL';

import { DbClusterParameterGroupSelect } from './dbClusterParameterGroupSelect';

export const DocumentdbParameterGroupSelect = ({
  accountId,
  regionName,
  parameterGroupName,
  onChange,
}: {
  accountId?: string;
  regionName?: string;
  parameterGroupName?: string;
  onChange: (name: string) => void;
}) => {
  const dal = useDAL();

  return (
    <DbClusterParameterGroupSelect
      accountId={accountId}
      regionName={regionName}
      parameterGroupName={parameterGroupName}
      onChange={onChange}
      useList={dal.restore.documentdbParameterGroups.useList}
      engineLabel='DocumentDB'
      testId='documentdbParameterGroupSelect'
    />
  );
};
